import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Act } from '../../logic/act';
import { Actions } from '../../logic/enum/actions';
import { text } from 'src/services/text.service';
import { Model } from 'src/logic/model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
    standalone: false
})
export class LoginComponent implements OnInit {

  Actions = Actions;
  text = text;

  loginValue: string = "";
  passwordValue: string = "";

  @ViewChild('inpLogin')
  inpLogin!: ElementRef;

  constructor(public model: Model, public act: Act) { }


  ngOnInit(): void {
    setTimeout(()=>{
      this.inpLogin.nativeElement.focus();
    }, 0);
  }


}
